import type { JoinProInfoPageType } from '@presentation/pages';
import agenda from './agenda.webp';
import booking from './booking.webp';
import page from './page.webp';
import seo from './seo.webp';

export { agenda, booking, page, seo };

export const SECTION_IMAGE_PER_TYPE: Record<JoinProInfoPageType, string> = {
  AGENDA: agenda,
  BOOKING: booking,
  PROFILE: page,
  SEO: seo,
};
